import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { TranslationProvider } from './context/TranslationContext';
import './styles.css';

import Header   from './components/Header';
import Footer   from './components/Footer';
import HomePage from './pages/HomePage';
import Blog     from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Privacy  from './pages/Privacy';
import NotFound from './pages/NotFound';

/* Al cambiar de ruta: arriba del todo, o a la sección si la URL trae #hash */
function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView(); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <TranslationProvider>
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/"           element={<HomePage />} />
          <Route path="/blog"       element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacidad" element={<Privacy />} />
          <Route path="*"           element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </TranslationProvider>
  );
}
